export const API_PATH_ApiDeviceMgmtLocationChangeRegion = '/services/devices-mgtm/apiDeviceMgmtLocationChangeRegion';
